module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_61"
    }
  }, [_c('span', [_vm._v("51")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e691461"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c4_r1#d6e9",
      "id": "d7e9"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Part 2")]), _c('br'), _c('br'), _c('i', [_vm._v("Joy ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e692261"
    }
  }, [_c('span', [_c('i', [_vm._v("See golden days, fruitful of golden deeds, with joy and love triumphing.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e692761"
    }
  }, [_c('span', [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILTON ")])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e693261"
    }
  }, [_c('span', [_c('i', [_vm._v("Joyful, joyful we adore Thee, "), _c('br'), _vm._v(" \nGod of glory, Lord of love; "), _c('br'), _vm._v(" \nHearts unfold like flowers before Thee, "), _c('br'), _vm._v(" \nopening to the sun above. "), _c('br'), _vm._v(" \nMelt the clouds of sin and sadness, "), _c('br'), _vm._v(" \ndrive the dark of doubt away; "), _c('br'), _vm._v(" \nGiver of immortal gladness, "), _c('br'), _vm._v(" \nfill us with the light of day.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e696161"
    }
  }, [_c('span', [_vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENRY ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YKE ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-046a38a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c13_r1.vue
// module id = 93
// module chunks = 0